class Runner {

	/**
	 * Create the runner.
	 */
	constructor( bot, tokens, functions ) {

		this.bot = bot;
		this.tokens = tokens;
		this.runTokens = [];
		this.functions = functions;
		this.timer = null;

	}


	/**
	 * Run the next command.
	 *
	 * @param {string} token The next command token.
	 * @return false|void
	 */
	runCommand( token = null ) {

		if ( !token ) {
			console.error( 'token empty', token );
			return;
		}

		const { bot } = this;

		const { type, arg, commands } = token;

		if ( 'repcount' === type ) {
			app.parser.setReservedVariable( 'loopcount', arg );
			return;
		}

		// Repeat commands.
		if ( 'repeat' === type ) {

			let method_arg = this.calculateArgs( arg );

			// Ensure the value we are looping over is an int.
			method_arg = parseInt( method_arg );

			// In "repeat tokens" the arg contains the number of loops to make.
			// We count down backwards since the commands are taken from the end of the array.
			for ( let i = method_arg; i > 0; i-- ) {
				// Add the commands to the token loop.
				this.runTokens.unshift( ...commands );
				// Set the repcount variable last because the commands are run in reverse order.
				// From the end of the array to the beginning.
				this.runTokens.unshift( new Token( 'repcount', i ) );
			}

			return;

		}

		// Execute functions.
		if ( this.functions && this.functions[ type ] ) {

			// console.log( 'execute function', type );

			const f = this.functions[ type ];

			// Make sure there's a list of commands with the function.
			if ( f.commands && f.commands.length ) {
				this.runTokens.unshift( ...this.functions[ type ].commands );
				return;
			}

		}

		// Execute built in keywords.
		if ( keywords[ type ] ) {

			// console.log( 'execute keyword', type );

			let method_arg = this.calculateArgs( arg );
			keywords[ type ]( method_arg );
			return;

		}

		// Execute commands.
		if ( commandList[ type ] ) {

			// console.log( 'execute command', type );

			const method = commandList[ type ][ 0 ];

			if ( bot[ method ] ) {

				let method_arg = this.calculateArgs( arg );
				bot[ method ]( method_arg );
				return;

			}

			console.error( 'Command method does not exist', method );

		}

		console.error( `token not known`, type );

	}


	/**
	 * Calculate arguments.
	 *
	 * @param {any} arg The arguments to calculate.
	 * @return {any}
	 */
	calculateArgs( arg ) {

		// console.log( 'calculateArgs', arg );

		/**
		 * We need to make sure we remove the reference when passing the
		 * arguments so that we don't modify the original object properties.
		 */
		let newArg = arg;
		if ( isArray( newArg ) ) {
			newArg = myArray.clone( newArg );
		}

		if ( isString( newArg ) ) {

			// Random numbers.
			if ( newArg.startsWith( 'random' ) ) {

				let values = newArg.replace( 'random ', '' ).split( ' ' );
				newArg = random.integer();

				// We need to check that the numbers are real in case of NaN's popping up.
				if ( 1 === values.length && isNumber( values[ 0 ] ) ) {
					newArg = random.integer( values[ 0 ] );
				}
				if ( 2 === values.length && isNumber( values[ 0 ] ) && isNumber( values[ 1 ] ) ) {
					newArg = random.integer( values[ 0 ], values[ 1 ] );
				}

			}

			// Variables.
			if ( isString( newArg ) && newArg.startsWith( '$' ) ) {

				const variable = newArg.replace( '$', '' );
				newArg = app.parser.getVariable( variable );

			}

			// Math.
			newArg = app.parser.evalMath( newArg );

		}

		// Recursively update if array.
		if ( isArray( newArg ) ) {
			for ( let i = 0; i < newArg.length; i++ ) {
				newArg[ i ] = this.calculateArgs( newArg[ i ] );
			}
			// console.log( 'calculate array', newArg );
		}

		return newArg;

	}


	/**
	 * Run the list of commands.
	 *
	 * @return {void}
	 */
	run() {

		const token = this.runTokens.shift();

		if ( !token ) {
			return;
		}

		/**
		 * Set a delay for the new command.
		 */
		let delay = 5;
		// Call the custom delay function.
		if ( commandListDelay && commandListDelay[ token.type ] ) {
			delay = commandListDelay[ token.type ]( token, delay );
		}

		this.runCommand( token );

		if ( token.type === 'delay' || token.type === 'wait' ) {
			delay = parseInt( token.arg );
		}

		clearTimeout( this.timer );
		this.timer = setTimeout(
			() => {
				this.run();
			},
			delay
		);

		ninjaEvent( 'run_command' );

	}


	/**
	 * Start running the sequence.
	 * Resets everything.
	 *
	 * @param {array} tokens List of tokens.
	 * @return {void}
	 */
	start( tokens = this.tokens ) {

		/**
		 * Clear the timer.
		 *
		 * We need to stop current processes before resetting so that things
		 * don't start in the wrong place.
		 */
		if ( this.timer ) {
			clearTimeout( this.timer );
		}

		ninjaEvent( 'run_begin' );

		random.seed = 0;

		// Reset the runTokens, then start again.
		this.runTokens = tokens;

		// Add a delay before anything happens to prepare the user.
		setTimeout(
			() => {
				this.run();
			},
			500
		);

	}


	/**
	 * Stop everything.
	 *
	 * @return {void}
	 */
	stop() {

		this.runTokens = [];
		clearTimeout( this.timer );

	}

}
